document.addEventListener('DOMContentLoaded', function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // intro curtain
  var curtain = document.getElementById('curtain');
  if (curtain) {
    setTimeout(function () { curtain.classList.add('curtain--hide'); }, reduced ? 0 : 1900);
  }

  // custom cursor — desktop / fine-pointer only, fully optional and additive
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine && !reduced) {
    var dot = document.getElementById('cursorDot');
    var ring = document.getElementById('cursorRing');
    // Only hide the native cursor once we've confirmed the replacement
    // elements actually exist — otherwise the site is left with no
    // cursor at all if the markup below is ever missing or moved.
    if (dot && ring) {
      document.documentElement.classList.add('has-fine-pointer');
      var mx = 0, my = 0, rx = 0, ry = 0;
      var viewMedia = null; // image element of the card currently hovered, if any

      window.addEventListener('mousemove', function (e) {
        mx = e.clientX; my = e.clientY;
        dot.style.left = mx + 'px'; dot.style.top = my + 'px';

        // Decide the VIEW state geometrically rather than by matching
        // the event target. Dawn stretches the card's title link across
        // the whole card via ::after to make it clickable, so the event
        // target is that same <a> whether the pointer is over the photo
        // or the price — element matching cannot tell them apart. The
        // rect is read live because scrolling moves it under the cursor.
        if (viewMedia) {
          var r = viewMedia.getBoundingClientRect();
          var inside = mx >= r.left && mx <= r.right && my >= r.top && my <= r.bottom;
          document.body.classList.toggle('cursor--view', inside);
        }
      });
      (function loop() {
        rx += (mx - rx) * 0.16; ry += (my - ry) * 0.16;
        ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
        requestAnimationFrame(loop);
      })();

      // "VIEW" label state.
      //
      // Previously bound to '.card, .card-wrapper', which includes the
      // card's text block — so the cursor expanded into VIEW while
      // reading a title or price, not just over the photograph. This
      // handler records which image region belongs to the hovered card;
      // the mousemove handler above decides, by cursor position, whether
      // the label should currently show.
      //
      // Delegated from document rather than bound per-element at load,
      // so cards injected later — product recommendations, filtered
      // collection results — get the same behavior. The old
      // querySelectorAll ran once at page load and never saw those.
      document.addEventListener('mouseover', function (e) {
        var card = e.target.closest('.card, .card-wrapper, .stp-tile');
        if (!card) {
          viewMedia = null;
          document.body.classList.remove('cursor--view');
          return;
        }
        // On the homepage Showcase the caption overlays the photo, so
        // the whole tile counts as image area.
        viewMedia = card.matches('.stp-tile') ? card : card.querySelector('.card__media');
        if (!viewMedia) document.body.classList.remove('cursor--view');
      });

      // Covers leaving the window entirely, where no further mouseover
      // fires and the label would otherwise stay stuck on. Bound to
      // documentElement — mouseleave doesn't bubble, so document itself
      // is not a reliable target for it.
      document.documentElement.addEventListener('mouseleave', function () {
        document.body.classList.remove('cursor--view');
      });
    }
  }
});

/* ============================================================
   PHASE 6 — Sitewide Feel
   Lenis smooth scroll + GSAP ScrollTrigger/SplitText foundation
   + paper-grain overlay.

   PASTE THIS AT THE VERY END of custom.js. It's a self-contained
   IIFE that doesn't reference or depend on the existing
   curtain/cursor code above it — nothing to merge, just append.

   Requires the CDN <script>/<link> tags added to theme.liquid
   (Lenis, GSAP, ScrollTrigger, SplitText) to have loaded first.
   ============================================================ */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Lenis smooth scroll ---------- */
  var lenis = null;
  if (!prefersReducedMotion && window.Lenis) {
    lenis = new Lenis({
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      syncTouch: false,        // native touch momentum on mobile — smoothed touch scroll tends to feel laggy, not luxurious
      anchors: true,            // smooth-scrolls same-page hash links (e.g. the #MainContent skip-to-content link)
      allowNestedScroll: true   // lets independently-scrolling containers (cart drawer, menus) keep working normally
    });
    window.stpLenis = lenis;    // exposed globally so later phases (the Codex pinned section, etc.) can reuse this instance
  }

  /* ---------- 2. GSAP + ScrollTrigger + SplitText ---------- */
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger, window.SplitText);

    if (lenis) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    }

    /* Kinetic heading reveal — add data-stp-reveal to any heading
       and it splits into lines that rise into place as it enters
       the viewport, like a line of a scroll unrolling. Runs once
       per element, waits for webfonts so lines measure correctly. */
    var runReveals = function () {
      var targets = document.querySelectorAll('[data-stp-reveal]');
      if (prefersReducedMotion || !window.SplitText) return; // leave headings visible, unsplit, un-animated

      targets.forEach(function (el) {
        SplitText.create(el, {
          type: 'lines,words',
          mask: 'lines',
          autoSplit: true,
          onSplit: function (self) {
            return gsap.from(self.lines, {
              yPercent: 110,
              opacity: 0,
              duration: 1,
              ease: 'power3.out',
              stagger: 0.08,
              scrollTrigger: {
                trigger: el,
                start: 'top 85%',
                once: true
              }
            });
          }
        });
      });
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(runReveals); // Cormorant/Jost need to be loaded before splitting, or lines mismeasure
    } else {
      runReveals();
    }
  }

  /* ---------- 3. Paper grain overlay ---------- */
  if (!document.querySelector('.stp-grain')) {
    var grain = document.createElement('div');
    grain.className = 'stp-grain';
    grain.setAttribute('aria-hidden', 'true');
    grain.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg">' +
        '<filter id="stpGrainFilter">' +
          '<feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch"></feTurbulence>' +
          '<feColorMatrix type="saturate" values="0"></feColorMatrix>' +
        '</filter>' +
        '<rect width="100%" height="100%" filter="url(#stpGrainFilter)"></rect>' +
      '</svg>';
    document.body.appendChild(grain);
  }
})();

/* ============================================================
   PHASE 7 — The Codex
   Upgrades the native horizontal scroll-snap baseline (already
   working via CSS alone) into a pinned scroll-jack sequence —
   desktop/no-touch/no-reduced-motion only. Mobile and reduced-
   motion visitors keep the plain swipeable strip: scroll-jacking
   on a small screen is uncomfortable to use one-handed, and this
   way there's nothing to break if GSAP fails to load.

   PASTE THIS AT THE END of custom.js, after the Phase 6 block —
   it depends on Lenis/GSAP/ScrollTrigger already being set up.
   ============================================================ */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia('(min-width: 900px) and (hover: hover)').matches;
  var codex = document.querySelector('[data-stp-codex]');

  if (!codex || prefersReducedMotion || !isDesktop || !window.gsap || !window.ScrollTrigger) {
    return; // leave the native horizontal scroll-snap baseline exactly as CSS renders it
  }

  var track = codex.querySelector('[data-stp-codex-track]');
  var viewport = codex.querySelector('.stp-codex-viewport');
  if (!track || !viewport) return;

  var setPin = function () {
    var distance = track.scrollWidth - viewport.clientWidth;
    if (distance <= 0) return; // not enough content to justify pinning — leave it as a static strip

    codex.classList.add('is-pinned');

    gsap.to(track, {
      x: -distance,
      ease: 'none',
      scrollTrigger: {
        trigger: codex,
        start: 'top top',
        end: '+=' + distance,
        scrub: true, // tied directly to scroll position — Lenis already supplies the smoothing/lag upstream, so adding scrub lag on top would feel mushy/doubled-up
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true
      }
    });
  };

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(setPin); // panel/track widths depend on fonts having settled first
  } else {
    setPin();
  }
})();

/* ============================================================
   PHASE 8 — Interaction Polish
   Magnetic buttons/links + curtain-wipe image reveals.

   PASTE THIS AT THE END of custom.js, after the Phase 6 block
   (and Phase 7, if you added it) — depends on GSAP/ScrollTrigger
   already being set up.
   ============================================================ */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;

  /* ---------- 1. Magnetic buttons/links ---------- */
  if (!prefersReducedMotion && canHover && window.gsap) {
    document.querySelectorAll('[data-stp-magnetic]').forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-stp-magnetic')) || 0.35;
      var xTo = gsap.quickTo(el, 'x', { duration: 0.45, ease: 'power3' });
      var yTo = gsap.quickTo(el, 'y', { duration: 0.45, ease: 'power3' });

      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var relX = e.clientX - rect.left - rect.width / 2;
        var relY = e.clientY - rect.top - rect.height / 2;
        xTo(relX * strength);
        yTo(relY * strength);
      });

      el.addEventListener('mouseleave', function () {
        xTo(0);
        yTo(0);
      });
    });
  }

  /* ---------- 2. Curtain-wipe image reveals ---------- */
  if (!prefersReducedMotion && window.gsap && window.ScrollTrigger) {
    document.querySelectorAll('[data-stp-image-reveal]').forEach(function (container) {
      var mask = container.querySelector('.stp-reveal-mask');
      if (!mask) return;

      gsap.to(mask, {
        scaleX: 0,
        duration: 1.1,
        ease: 'power4.inOut',
        scrollTrigger: {
          trigger: container,
          start: 'top 85%',
          once: true
        }
      });
    });
  }
})();

/* ============================================================
   PHASE 11 — Quick View  (rewritten in Phase 15, money fixed 32)
   Single-column, image-focused layout: auto-cycling slideshow
   with arrow + dot navigation at top, price/size/Add to Cart
   overlaid at the bottom. No separate details column.

   PHASE 32 — the only change in this revision is money().
   It used to read:

     if (window.Shopify && typeof Shopify.formatMoney === 'function') { ... }
     return '$' + (cents / 100).toFixed(2);

   Shopify.formatMoney ships with the old option_selection.js,
   which Dawn does not load — so that check never passed and every
   price fell through to the hardcoded dollar sign. The card read
   €710,00 EUR and the quick view beside it read $710.00.

   Rather than hardcode a different symbol — which breaks again
   the day a second currency is switched on — the format is now
   read off a price Liquid has already rendered on the page. That
   string is authoritative: the shop's own money format, through
   Shopify's own filters, in whatever currency the current market
   resolved to. See learnMoneyFormat() below.

   PASTE THIS AT THE END of custom.js, after the Phase 6 block
   (uses window.stpLenis if present, to pause smooth-scroll while
   the modal is open — harmless if Phase 6 isn't installed).
   REPLACES the previous Phase 11 block entirely — don't paste
   this alongside an older version.
   ============================================================ */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root, dialog, body, closeBtn, lastFocused, currentProduct, currentVariant;
  var productImages = [];
  var slideIndex = 0;
  var slideTimer = null;

  // Shopify's product JSON has, in practice, varied in whether array
  // entries are plain URL strings or objects with a .src — normalizing
  // here means a shape mismatch degrades to a missing image, not a
  // thrown error.
  function imgSrc(entry) {
    if (!entry) return '';
    return typeof entry === 'string' ? entry : (entry.src || '');
  }

  function resizeImg(url, width) {
    if (!url) return url;
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    return url + sep + 'width=' + width;
  }

  // ---- Money ------------------------------------------------
  // The format is learned once from a price Liquid already put on
  // the page, then applied to the cents the product JSON returns.
  var moneyFormat = null;

  // Dawn sets a visually-hidden "Regular price" label beside the
  // number, so the node is cloned and the label stripped before
  // reading — the same approach the collection rail takes with the
  // banner heading.
  function moneySample() {
    var nodes = document.querySelectorAll('.price-item--regular, .price-item');
    for (var i = 0; i < nodes.length; i++) {
      var clone = nodes[i].cloneNode(true);
      var hidden = clone.querySelectorAll('.visually-hidden');
      for (var h = 0; h < hidden.length; h++) hidden[h].parentNode.removeChild(hidden[h]);
      var text = clone.textContent.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
      if (/\d/.test(text)) return text;
    }
    return null;
  }

  function learnMoneyFormat() {
    var text = moneySample();
    if (!text) return null;
    var m = text.match(/^(.*?)(\d[\d.,\u2019' ]*\d|\d)(.*)$/);
    if (!m) return null;

    var core = m[2];

    // A separator followed by exactly two digits at the very end is
    // the decimal mark. Currencies with no minor unit — yen, won —
    // simply have none, and format whole.
    var decSep = '';
    var decimals = 0;
    var tail = core.match(/([.,])(\d{2})$/);
    if (tail) {
      decSep = tail[1];
      decimals = 2;
    }

    // Whatever else separates digits is the thousands mark. A sample
    // under a thousand shows none, so fall back to the mark that
    // conventionally pairs with the decimal one.
    var rest = core.replace(/([.,])\d{2}$/, '').match(/[.,\u2019' ]/g);
    var thouSep = '';
    if (rest && rest.length) {
      thouSep = rest[0];
    } else if (decSep === ',') {
      thouSep = '.';
    } else if (decSep === '.') {
      thouSep = ',';
    }
    if (thouSep === decSep) thouSep = decSep === ',' ? '.' : ',';

    return { prefix: m[1], suffix: m[3], decSep: decSep, decimals: decimals, thouSep: thouSep };
  }

  // Last resort, for a page carrying no Liquid-rendered price at
  // all. Intl gets the symbol and separators right for the active
  // currency; it may not match the shop's exact template, but it
  // will never invent dollars.
  function moneyViaIntl(cents) {
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: code
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + code;
    }
  }

  // The cents from /products/x.js are used as they arrive.
  // Shopify.currency.rate is deliberately NOT applied: the endpoint
  // already answers in the market's presentment currency, so
  // multiplying would convert a second time.
  function money(cents) {
    if (moneyFormat === null) moneyFormat = learnMoneyFormat() || false;
    if (!moneyFormat) return moneyViaIntl(cents);

    var f = moneyFormat;
    var negative = cents < 0;
    var fixed = (Math.abs(cents) / 100).toFixed(f.decimals);
    var parts = fixed.split('.');
    var whole = parts[0];
    var frac = parts[1] || '';
    if (f.thouSep) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, f.thouSep);
    return (negative ? '-' : '') + f.prefix + whole + (frac ? f.decSep + frac : '') + f.suffix;
  }
  // -----------------------------------------------------------

  function buildShell() {
    root = document.createElement('div');
    root.className = 'stp-quickview';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="stp-quickview__backdrop"></div>' +
      '<div class="stp-quickview__dialog" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button type="button" class="stp-quickview__close" aria-label="Close">&times;</button>' +
        '<div class="stp-quickview__body"></div>' +
      '</div>';
    document.body.appendChild(root);

    dialog = root.querySelector('.stp-quickview__dialog');
    body = root.querySelector('.stp-quickview__body');
    closeBtn = root.querySelector('.stp-quickview__close');

    closeBtn.addEventListener('click', closeQuickView);
    root.querySelector('.stp-quickview__backdrop').addEventListener('click', closeQuickView);
    document.addEventListener('keydown', function (e) {
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeQuickView();
      if (e.key === 'Tab') trapFocus(e);
      if (e.key === 'ArrowLeft') { goToSlide(slideIndex - 1); restartSlideshow(); }
      if (e.key === 'ArrowRight') { goToSlide(slideIndex + 1); restartSlideshow(); }
    });
  }

  function trapFocus(e) {
    var focusable = dialog.querySelectorAll('button, [href], select, input, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openQuickView(handle) {
    if (!root) buildShell();
    lastFocused = document.activeElement;
    body.innerHTML = '<p class="stp-quickview__status">Loading\u2026</p>';
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (window.stpLenis) window.stpLenis.stop();
    closeBtn.focus();

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then(renderProduct)
      .catch(function (err) {
        body.innerHTML =
          '<p class="stp-quickview__status stp-quickview__status--error">' +
          'This piece couldn\u2019t be loaded. <a href="/products/' + handle + '">View its full page instead</a>.' +
          '</p>';
        if (window.console) console.error('Quick view failed to render:', err);
      });
  }

  function closeQuickView() {
    stopSlideshow();
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (window.stpLenis) window.stpLenis.start();
    if (lastFocused) lastFocused.focus();
  }

  function renderProduct(product) {
    currentProduct = product;
    currentVariant = product.variants[0];

    var rawImages = (product.images && product.images.length) ? product.images : [product.featured_image];
    productImages = rawImages.map(imgSrc).filter(Boolean);
    if (!productImages.length) productImages = [''];
    slideIndex = 0;

    var optionsHtml = '';
    if (product.variants.length > 1) {
      product.options.forEach(function (option, i) {
        var optionName = (option && option.name) ? option.name : ('Option ' + (i + 1));
        var values = [];
        product.variants.forEach(function (v) {
          if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]);
        });
        optionsHtml +=
          '<div class="stp-quickview__option">' +
            '<select id="stp-qv-option-' + i + '" data-stp-option-index="' + i + '" aria-label="' + optionName + '">' +
              values.map(function (val) {
                return '<option value="' + val + '">' + val + '</option>';
              }).join('') +
            '</select>' +
          '</div>';
      });
    }

    var slidesHtml = productImages.map(function (src, idx) {
      return '<img class="stp-quickview__slide' + (idx === 0 ? ' is-active' : '') + '" src="' +
        resizeImg(src, 900) + '" alt="' + product.title.replace(/"/g, '&quot;') + '">';
    }).join('');

    var navHtml = '';
    if (productImages.length > 1) {
      var dots = productImages.map(function (_, idx) {
        return '<button type="button" class="stp-quickview__dot' + (idx === 0 ? ' is-active' : '') +
          '" data-stp-dot="' + idx + '" aria-label="Show image ' + (idx + 1) + '"></button>';
      }).join('');
      navHtml =
        '<div class="stp-quickview__nav">' +
          '<button type="button" class="stp-quickview__arrow" data-stp-prev aria-label="Previous image">\u2039</button>' +
          '<div class="stp-quickview__dots">' + dots + '</div>' +
          '<button type="button" class="stp-quickview__arrow" data-stp-next aria-label="Next image">\u203a</button>' +
        '</div>';
    }

    body.innerHTML =
      '<div class="stp-quickview__media">' +
        '<div class="stp-quickview__slides">' + slidesHtml + '</div>' +
        navHtml +
        '<div class="stp-quickview__controls">' +
          '<div class="stp-quickview__price" data-stp-price></div>' +
          '<div class="stp-quickview__controls-row">' +
            optionsHtml +
            '<button type="button" class="button stp-quickview__add" data-stp-add>Add to Cart</button>' +
          '</div>' +
          '<p class="stp-quickview__status" data-stp-status></p>' +
        '</div>' +
      '</div>';

    body.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
    body.querySelector('[data-stp-add]').addEventListener('click', handleAddToCart);
    body.querySelectorAll('[data-stp-dot]').forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(parseInt(dot.getAttribute('data-stp-dot'), 10));
        restartSlideshow();
      });
    });
    var prevBtn = body.querySelector('[data-stp-prev]');
    var nextBtn = body.querySelector('[data-stp-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(slideIndex - 1); restartSlideshow(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(slideIndex + 1); restartSlideshow(); });

    var mediaEl = body.querySelector('.stp-quickview__media');
    mediaEl.addEventListener('mouseenter', stopSlideshow);
    mediaEl.addEventListener('mouseleave', restartSlideshow);

    updatePriceAndAvailability();
    if (!prefersReducedMotion) startSlideshow();
  }

  function goToSlide(idx) {
    if (!productImages.length) return;
    idx = ((idx % productImages.length) + productImages.length) % productImages.length; // wrap both directions
    slideIndex = idx;
    body.querySelectorAll('.stp-quickview__slide').forEach(function (s, i) {
      s.classList.toggle('is-active', i === idx);
    });
    body.querySelectorAll('.stp-quickview__dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
  }

  function startSlideshow() {
    stopSlideshow();
    if (productImages.length <= 1) return;
    slideTimer = setInterval(function () {
      goToSlide(slideIndex + 1);
    }, 3200);
  }

  function stopSlideshow() {
    if (slideTimer) { clearInterval(slideTimer); slideTimer = null; }
  }

  function restartSlideshow() {
    if (!prefersReducedMotion) startSlideshow();
  }

  function updateVariant() {
    var selected = [];
    body.querySelectorAll('select').forEach(function (s) { selected.push(s.value); });

    var match = currentProduct.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    if (match) {
      currentVariant = match;
      var newSrc = imgSrc(match.featured_image);
      if (newSrc) {
        var idx = productImages.indexOf(newSrc);
        if (idx > -1) {
          goToSlide(idx);
          restartSlideshow();
        }
      }
    }
    updatePriceAndAvailability();
  }

  function updatePriceAndAvailability() {
    var priceEl = body.querySelector('[data-stp-price]');
    var addBtn = body.querySelector('[data-stp-add]');
    if (!priceEl || !addBtn) return;

    if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
      priceEl.innerHTML = '<s>' + money(currentVariant.compare_at_price) + '</s> ' + money(currentVariant.price);
    } else {
      priceEl.textContent = money(currentVariant.price);
    }

    if (currentVariant.available) {
      addBtn.disabled = false;
      addBtn.textContent = 'Add to Cart';
    } else {
      addBtn.disabled = true;
      addBtn.textContent = 'Sold Out';
    }
  }

  function handleAddToCart() {
    var addBtn = body.querySelector('[data-stp-add]');
    var statusEl = body.querySelector('[data-stp-status]');
    addBtn.disabled = true;
    addBtn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentVariant.id, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        statusEl.className = 'stp-quickview__status stp-quickview__status--success';
        statusEl.innerHTML = 'Added to your cart. <a href="/cart">View Cart</a>';
        addBtn.textContent = 'Add to Cart';
        addBtn.disabled = false;
      })
      .catch(function () {
        statusEl.className = 'stp-quickview__status stp-quickview__status--error';
        statusEl.textContent = 'Something went wrong \u2014 please try again, or visit the product page directly.';
        addBtn.textContent = 'Add to Cart';
        addBtn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-stp-quickview]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    openQuickView(trigger.getAttribute('data-product-handle'));
  });
})();

/* ============================================================
   PHASE 20 — Related products: "The Reels"

   Restructures Dawn's related-products grid into three columns
   (two on mobile) of vertically cascading pieces. Each column runs
   on its own clock and loops continuously downward; hovering holds
   only the column under the cursor.

   REPLACES the previous Phase 20 block ("The Adjacent" horizontal
   scroller) entirely — remove that one, don't paste this alongside it.
   PASTE AT THE END of custom.js.
   ============================================================ */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Seconds for one column to travel a full set. Deliberately not
  // multiples of each other, so the columns never fall into step.
  var DURATIONS = [58, 74, 92];
  var COLUMNS = 3;                     // Shopify's recommendations API caps at
                                       // 10 products; three columns partition
                                       // that cleanly as 4/3/3 with no repeats
  var MIN_PRODUCTS = 3;                // below this, leave Dawn's grid alone


  // Quick View, matching the collection grid. The product handle is read
  // from the card's own link rather than passed in, since these cards
  // are clones of whatever Dawn rendered.
  function addQuickView(slide, clone) {
    var link = clone.querySelector('a[href*="/products/"]');
    if (!link) return;
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!match) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'stp-quickview-trigger';
    btn.setAttribute('data-stp-quickview', '');
    btn.setAttribute('data-product-handle', match[1]);
    var title = clone.querySelector('.card__heading');
    btn.setAttribute('aria-label', 'Quick view' + (title ? ' ' + title.textContent.trim() : ''));
    btn.textContent = 'Quick View';
    slide.appendChild(btn);
  }

  function build(container) {
    var grid = container.querySelector('.product-grid');
    if (!grid || grid.dataset.stpReels) return;

    var cards = [].slice.call(grid.children);
    if (cards.length < MIN_PRODUCTS) return; // not enough to fill columns
    grid.dataset.stpReels = '1';

    var stage = document.createElement('div');
    stage.className = 'stp-reels__stage';

    // With enough products, each column gets its OWN slice of the set
    // (round-robin), so no piece ever appears in two columns — you
    // never see the same garment twice on screen. That needs at least
    // two products per column; below that there simply are not enough
    // to go round, so the columns fall back to carrying the whole set
    // at different offsets, which repeats but never stalls.
    var partition = cards.length >= COLUMNS * 2;

    for (var c = 0; c < COLUMNS; c++) {
      var reel = document.createElement('div');
      reel.className = 'stp-reel';
      var track = document.createElement('div');
      track.className = 'stp-reel__track';

      var seq = [];
      if (partition) {
        for (var k = c; k < cards.length; k += COLUMNS) seq.push(k);
      } else {
        var offset = Math.round((c * cards.length) / COLUMNS);
        for (var m = 0; m < cards.length; m++) seq.push((m + offset) % cards.length);
      }

      // Exactly two copies of the set. The CSS animation translates the
      // track by half its own height, which lands on an identical frame
      // — so the loop is seamless. This count must stay at two.
      for (var pass = 0; pass < 2; pass++) {
        for (var i = 0; i < seq.length; i++) {
          var srcIndex = seq[i];
          var slide = document.createElement('div');
          slide.className = 'stp-reel__slide';
          // Number reflects the piece, not its position in the loop.
          slide.setAttribute('data-stp-no', ('0' + (srcIndex + 1)).slice(-2));

          var clone = cards[srcIndex].cloneNode(true);
          slide.appendChild(clone);
          addQuickView(slide, clone);

          track.appendChild(slide);
        }
      }

      reel.appendChild(track);
      reel.dataset.steps = seq.length;
      stage.appendChild(reel);
    }

    grid.parentNode.insertBefore(stage, grid);
    grid.style.display = 'none'; // kept in the DOM so Dawn's own scripts
                                 // never find themselves missing an element

    container.classList.add('stp-reels');
    animate(stage);
  }

  // Motion is handled entirely in CSS (see .stp-reel__track animation).
  // The previous build stepped the columns with JS, which meant
  // measuring every slide's offset — unreliable with lazy-loaded images
  // at natural heights, since the measurements are wrong until each one
  // loads. A CSS loop has nothing to measure: the track holds exactly
  // two copies of the set, and translating it by half its own height
  // lands on an identical frame. Each column just gets its own duration.
  function animate(stage) {
    [].slice.call(stage.querySelectorAll('.stp-reel__track')).forEach(function (track, i) {
      track.style.animationDuration = (DURATIONS[i] || 60) + 's';
    });
  }

  function boot() {
    document.querySelectorAll('product-recommendations, .related-products').forEach(build);
  }

  boot();

  // Recommendations arrive by AJAX after page load, so the grid usually
  // does not exist yet at this point.
  var host = document.querySelector('product-recommendations, .related-products');
  if (host) {
    new MutationObserver(boot).observe(host, { childList: true, subtree: true });
  }
})();

/* ============================================================
   PHASE 26 — Collections index: the pieces turn on their own
   REWRITTEN in Phase 40. This replaces the previous Phase 26
   block entirely — there is only ever one of these in the file.

   Before, the frames sat hidden and only turned while a row was
   held. Now every row shows its pieces from the start, dimmed
   against the ink, and turns them on a clock of its own; holding
   a row quickens the cadence and lifts the photograph to full
   strength (the opacity is CSS — see Phase 40).

   Three things this had to get right:

   · Each row's period is DERIVED FROM ITS INDEX rather than read
     from a list, so the rhythm holds for six collections or
     twenty with nothing to edit. 7 and 11 are coprime, so
     (i * 7) % 11 runs through all eleven residues before
     repeating — no two of the first eleven rows share a period,
     and the opening offsets are scattered on top of that, so the
     rows never fall into step even after a reload.

   · Leaving a row no longer resets it to the first piece. The old
     block could do that because the frames were invisible at
     rest; now a reset would be a visible jump, so a row simply
     returns to its resting cadence wherever it had got to.

   · The z-index is dropped back after every sweep. The old block
     let it climb, which was harmless when a cycle lasted only as
     long as a hover and is not when it runs for as long as the
     page is open.
   ============================================================ */
(function () {
  'use strict';

  var WIPE_MS = 1000; /* the sweep itself */
  var HOVER_HOLD = 1700; /* time on a piece while a row is held */
  var REST_HOLD = 4600; /* time on a piece at rest — ambient, not busy */
  var SPREAD = 430; /* how far apart consecutive rows' clocks sit */
  var SCATTER = 1600; /* opening offset per row */

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* Below 750px the CSS shows the first frame only and hides the
     rest, so there is nothing to turn down there. */
  var wide = window.matchMedia('(min-width: 750px)');

  function periodFor(i, hold) {
    return WIPE_MS + hold + ((i * 7) % 11) * SPREAD;
  }

  function init(row, i) {
    if (row.dataset.stpIndexTurn) return;
    row.dataset.stpIndexTurn = '1';

    var frames = [].slice.call(row.querySelectorAll('.stp-index__frame'));
    if (frames.length < 2) return; /* a lone piece has nothing to cycle */

    var index = 0;
    var layer = 1;
    var timer = null;
    var startTimer = null;
    var held = false;

    function next() {
      index = (index + 1) % frames.length;
      var el = frames[index];

      /* Raise the incoming frame above the one showing, snap it back
         to clipped with no transition, force a reflow so the browser
         registers that as a starting point, then sweep it open.
         Without the reflow the two style changes collapse into one
         and nothing animates. */
      el.style.zIndex = ++layer;
      el.style.transition = 'none';
      el.style.clipPath = 'inset(0 100% 0 0)';
      void el.offsetWidth;
      el.style.transition = 'clip-path ' + WIPE_MS + 'ms cubic-bezier(.6,.01,.2,1)';
      el.style.clipPath = 'inset(0 0 0 0)';

      /* Once the sweep has finished the incoming photograph covers
         the frame completely, so everything behind it can be put
         back to clipped and the layer counter reset. The guard
         covers a backgrounded tab, where timers are throttled and
         the next turn can start first. */
      var showing = index;
      setTimeout(function () {
        if (showing !== index) return;
        frames.forEach(function (other, n) {
          if (n === index) return;
          other.style.transition = 'none';
          other.style.zIndex = 0;
          other.style.clipPath = 'inset(0 100% 0 0)';
        });
        el.style.zIndex = 1;
        layer = 1;
      }, WIPE_MS + 80);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
      }
    }

    function run(hold, delay) {
      stop();
      if (reduceMotion || !wide.matches) return;
      startTimer = setTimeout(function () {
        next();
        timer = setInterval(next, periodFor(i, hold));
      }, delay);
    }

    function rest() {
      held = false;
      run(REST_HOLD, 0);
    }

    function quicken() {
      held = true;
      run(HOVER_HOLD, 0);
    }

    run(REST_HOLD, (i * SCATTER) % periodFor(i, REST_HOLD));

    row.addEventListener('mouseenter', quicken);
    row.addEventListener('mouseleave', rest);
    row.addEventListener('focus', quicken);
    row.addEventListener('blur', rest);

    /* A backgrounded tab throttles timers, and several rows can
       queue up and fire together on return — exactly the in-step
       look this exists to avoid. Everything is stood down while
       the tab is hidden and restarted on its own offset. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        run(held ? HOVER_HOLD : REST_HOLD, (i * SCATTER) % periodFor(i, REST_HOLD));
      }
    });

    /* Crossing the 750px breakpoint hands the rows to the CSS's
       static mobile treatment and back again. */
    if (wide.addEventListener) {
      wide.addEventListener('change', rest);
    }
  }

  function boot() {
    var rows = document.querySelectorAll('.stp-index__row');
    [].forEach.call(rows, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor replaces the section's markup on every setting
     change. init is guarded by a dataset flag, so re-running is free. */
  document.addEventListener('shopify:section:load', boot);
})();

/* ============================================================
   PHASE 27 (REBUILD) — Collection page
   Replaces the whole previous Phase 27 block (27, 27b, 27c, 27d,
   27e). Delete those five blocks from custom.js and paste this in
   their place.

   What it does, in order:
     · builds the rail head by MOVING the banner's real <h1> and
       description into the rail, then removing the banner section
     · sweeps the stray '>' left in the rail by an old hand edit
     · reads the product count once and writes a single line into
       the rail (Dawn renders that count more than once, which is
       why it was appearing twice)
     · redistributes the flat product list into three real column
       elements, so one column can widen on its own
     · holds the open state in a class rather than :hover, so a
       card resizing under the cursor cannot toggle itself
     · turns a card through its further views while it is open
     · makes the whole tile clickable as a safety net behind the
       title link's own overlay

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var COLUMNS = 3;
  var OPEN = 'stp-open';
  var GRID = '#ProductGridContainer .product-grid';
  var RAIL = 'main-collection-filters';

  var HOLD_MS = 1500; /* the first view is held before anything moves */
  var WIPE_MS = 900; /* the sweep itself */
  var STEP_MS = 2200; /* time on each view thereafter */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onCollection() {
    return (
      location.pathname.indexOf('/collections/') !== -1 &&
      location.pathname.indexOf('/products/') === -1 &&
      !!document.getElementById(RAIL)
    );
  }

  /* The CSS is scoped to main[data-template='collection']. If
     theme.liquid ever stops writing that attribute, every rule in
     Phase 27 goes dead at once, so it is guaranteed here. */
  function stampTemplate() {
    var main = document.querySelector('main');
    if (main && !main.getAttribute('data-template')) {
      main.setAttribute('data-template', 'collection');
    }
  }

  /* ---------- 1. The rail head ---------- */

  /* An old hand edit to main-collection-product-grid.liquid left a
     bare '>' loose in the aside, which renders as a lone character
     in the rail. Only punctuation that cannot be real copy is
     swept — a stray currency symbol or dash is left alone. */
  function sweepStrays(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var doomed = [];
    var node;
    while ((node = walker.nextNode())) {
      var text = node.textContent.trim();
      if (text && text.length <= 2 && /^[<>{}%|\\]+$/.test(text)) doomed.push(node);
    }
    doomed.forEach(function (n) {
      if (n.parentNode) n.parentNode.removeChild(n);
    });
  }

  function buildHead() {
    var rail = document.getElementById(RAIL);
    if (!rail) return;
    var hero = document.querySelector('.collection-hero');

    if (!rail.querySelector('.stp-rail__head')) {
      var head = document.createElement('div');
      head.className = 'stp-rail__head';

      var eyebrow = document.createElement('span');
      eyebrow.className = 'stp-rail__eyebrow';
      eyebrow.textContent = 'The Catalogue';
      head.appendChild(eyebrow);

      /* The heading is MOVED rather than copied, so the page keeps
         one real <h1> carrying the collection name. */
      var titleEl = hero ? hero.querySelector('.collection-hero__title') : null;
      if (titleEl) {
        var hidden = titleEl.querySelector('.visually-hidden');
        if (hidden) hidden.remove(); /* Dawn's "Collection:" prefix */
        titleEl.className = 'stp-rail__title';
        titleEl.removeAttribute('style');
        head.appendChild(titleEl);
      } else {
        var h = document.createElement('h1');
        h.className = 'stp-rail__title';
        h.textContent = (document.title || '').split('\u2013')[0].trim();
        head.appendChild(h);
      }

      var descEl = hero ? hero.querySelector('.collection-hero__description') : null;
      if (descEl && descEl.textContent.trim()) {
        descEl.className = 'stp-rail__desc';
        descEl.removeAttribute('style');
        head.appendChild(descEl);
      }

      rail.insertBefore(head, rail.firstChild);
    }

    sweepStrays(rail);

    /* The banner has been absorbed; remove the section so it leaves
       no empty band behind. */
    if (hero) {
      var section = hero.closest('.shopify-section') || hero;
      if (section && section.parentNode) section.parentNode.removeChild(section);
    }
  }

  /* ---------- 2. One count, at the foot of the rail ---------- */
  function syncCount() {
    var rail = document.getElementById(RAIL);
    if (!rail) return;

    var source = document.querySelector(
      '.product-count__text, .product-count, [id^="ProductCount"]'
    );
    var text = source ? source.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!text) return;
    text = text.replace(/\bproducts\b/i, 'pieces').replace(/\bproduct\b/i, 'piece');

    var line = rail.querySelector('.stp-rail__count');
    if (!line) {
      if (!rail.querySelector('.stp-rail__seal')) {
        var seal = document.createElement('span');
        seal.className = 'stp-rail__seal';
        seal.setAttribute('aria-hidden', 'true');
        seal.textContent = '\u76db\u5510\u7261\u4e39';
        rail.appendChild(seal);
      }
      line = document.createElement('div');
      line.className = 'stp-rail__count';
      line.setAttribute('role', 'status');
      rail.appendChild(line);
    }
    if (line.textContent !== text) line.textContent = text;
  }

  /* ---------- 3. Three real columns ---------- */
  function colCount() {
    if (window.matchMedia('(max-width: 749px)').matches) return 1;
    if (window.matchMedia('(max-width: 989px)').matches) return 2;
    return COLUMNS;
  }

  function columnate() {
    var grid = document.querySelector(GRID);
    if (!grid) return;

    var n = colCount();
    if (grid.dataset.stpColumns === String(n) && grid.querySelector('.stp-col')) return;

    /* Recover the flat order first, so this is safe to run again on
       resize or after AJAX filtering. */
    var items = [].slice.call(grid.querySelectorAll('.grid__item'));
    if (!items.length) return;

    var frag = document.createDocumentFragment();
    var cols = [];
    for (var c = 0; c < n; c++) {
      var col = document.createElement('li');
      col.className = 'stp-col';
      frag.appendChild(col);
      cols.push(col);
    }
    items.forEach(function (item, i) {
      cols[i % n].appendChild(item);
    });

    grid.textContent = '';
    grid.appendChild(frag);
    grid.dataset.stpColumns = String(n);
  }

  /* ---------- 4. A stable open state ----------
     Opening a card changes its own geometry. If that edge moved
     past the cursor under :hover, mouseleave would fire, the card
     would close, the cursor would be over it again, and it would
     reopen — a flicker loop that :hover cannot escape, because the
     thing it depends on is the thing that moves.

     So the state lives in a class. A card opens on pointer-enter
     and closes only when the pointer leaves the whole GRID, which
     the card's own resizing can never cause: the open plate
     overflows its tile but is still a descendant of the grid, so
     hovering it is never "leaving". */
  function clearOpen() {
    var open = document.querySelectorAll('.' + OPEN);
    [].forEach.call(open, function (el) {
      el.classList.remove(OPEN);
    });
  }

  function bindGrid() {
    var grid = document.querySelector(GRID);
    if (!grid || grid.dataset.stpBound) return;
    grid.dataset.stpBound = '1';

    grid.addEventListener('mouseover', function (e) {
      var item = e.target.closest && e.target.closest('.grid__item');
      if (!item || !grid.contains(item)) return;
      if (item.classList.contains(OPEN)) return;
      clearOpen(); /* only one piece open at a time, anywhere */
      item.classList.add(OPEN);
    });

    grid.addEventListener('mouseleave', function () {
      clearOpen();
    });

    grid.addEventListener('focusin', function (e) {
      var item = e.target.closest && e.target.closest('.grid__item');
      if (!item) return;
      clearOpen();
      item.classList.add(OPEN);
    });
  }

  /* ---------- 5. Turning through the views ----------
     A card holds several photographs of the piece. While one is
     open it turns through them after a pause — the same wipe as
     the related-products reels, so the two behave alike. */
  function initFrames(item) {
    if (item.dataset.stpFrames) return;
    var media = item.querySelector('.card__media .media');
    if (!media) return;
    var frames = [].slice.call(media.querySelectorAll('.stp-frame'));
    if (!frames.length) return;
    item.dataset.stpFrames = '1';

    var index = -1; /* -1 is the resting photograph beneath the frames */
    var layer = 1;
    var startTimer = null;
    var stepTimer = null;

    function reset() {
      index = -1;
      layer = 1;
      frames.forEach(function (f) {
        f.style.transition = 'none';
        f.style.zIndex = 0;
        f.style.clipPath = 'inset(0 100% 0 0)';
      });
    }

    function next() {
      index = (index + 1) % frames.length;
      var el = frames[index];
      el.style.zIndex = ++layer;
      el.style.transition = 'none';
      el.style.clipPath = 'inset(0 100% 0 0)';
      /* Force layout so the browser treats the clipped state as a
         starting point; without it both changes collapse into one
         and the frame simply appears. */
      void el.offsetWidth;
      el.style.transition = 'clip-path ' + WIPE_MS + 'ms cubic-bezier(.6,.01,.2,1)';
      el.style.clipPath = 'inset(0 0 0 0)';
    }

    function stop() {
      if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
      }
      if (stepTimer) {
        clearInterval(stepTimer);
        stepTimer = null;
      }
    }

    function start() {
      if (reduceMotion) return;
      stop();
      startTimer = setTimeout(function () {
        next();
        stepTimer = setInterval(next, STEP_MS);
      }, HOLD_MS);
    }

    reset();

    /* Follows the open state rather than raw hover, so a card that
       is resizing does not restart its own sequence. */
    new MutationObserver(function () {
      if (item.classList.contains(OPEN)) {
        start();
      } else {
        stop();
        reset();
      }
    }).observe(item, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- 6. The whole tile is clickable ----------
     The title link's ::after overlay already covers the tile, so
     this is a safety net for the case where something else in the
     card ends up on top of it. */
  function initClick(item) {
    if (item.dataset.stpClick) return;
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return;
    item.dataset.stpClick = '1';
    var url = link.getAttribute('href');

    item.addEventListener('click', function (e) {
      /* Anything already interactive keeps its own behaviour. */
      if (e.target.closest('a, button')) return;
      /* Modified clicks behave as they would on a real link. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      window.location.href = url;
    });
  }

  function initItems() {
    var items = document.querySelectorAll('#ProductGridContainer .grid__item');
    [].forEach.call(items, function (item) {
      initFrames(item);
      initClick(item);
    });
  }

  /* ---------- Boot ---------- */
  var watching = false;

  function build() {
    if (!onCollection()) return;
    stampTemplate();
    buildHead();
    syncCount();
    columnate();
    bindGrid();
    initItems();
    if (!watching) {
      watching = true;
      watch(document.getElementById('ProductGridContainer'));
      watch(document.getElementById(RAIL));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      columnate();
      initItems();
    }, 200);
  });

  /* Filtering and sorting replace the grid and the facets by AJAX,
     so anything set up at load is lost in that swap (§4.7). Both
     hosts are watched, and every step above is idempotent, so
     re-running them cannot compound. */
  function watch(node) {
    if (!node) return;
    new MutationObserver(function () {
      if (!onCollection()) return;
      var grid = document.querySelector(GRID);
      if (grid && !grid.querySelector('.stp-col')) {
        grid.dataset.stpColumns = '';
        columnate();
      }
      bindGrid();
      initItems();
      syncCount();
    }).observe(node, { childList: true, subtree: true });
  }
})();

/* ============================================================
   PHASE 28 — Related products: the reels turn again

   The reels used to hold a piece for a moment and then show its
   second view. That was done in CSS — an opacity fade with a 1.5s
   delay — and it worked while a card carried exactly two images.
   card-product.liquid now renders up to four views per piece, and
   a delayed fade cannot step through four things: they all arrived
   together and the last one simply covered the rest.

   So the reels get the same wipe the collection cards use: hold,
   then sweep each view across, one after another. The CSS in Phase
   28 clips the views; this drives them.

   It also makes the whole slide clickable. Dawn stretches the
   title link's ::after over .card, but Phase 20 made the caption
   position:absolute, which turns the caption into that overlay's
   containing block — so the overlay shrank to the caption bar and
   the photograph itself did nothing. The real link is left in the
   markup, so keyboard, middle-click and search engines are
   unaffected.

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var HOLD_MS = 1500; /* the piece is held before anything moves */
  var WIPE_MS = 900; /* the sweep itself */
  var STEP_MS = 2200; /* time on each view thereafter */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initFrames(slide) {
    if (slide.dataset.stpFrames) return;
    var media = slide.querySelector('.card__media .media') || slide.querySelector('.card__media');
    if (!media) return;
    var frames = [].slice.call(media.querySelectorAll('.stp-frame'));
    if (!frames.length) return;
    slide.dataset.stpFrames = '1';

    var index = -1; /* -1 is the resting photograph beneath the views */
    var layer = 1;
    var startTimer = null;
    var stepTimer = null;

    function reset() {
      index = -1;
      layer = 1;
      frames.forEach(function (f) {
        f.style.transition = 'none';
        f.style.zIndex = 0;
        f.style.clipPath = 'inset(0 100% 0 0)';
      });
    }

    function next() {
      index = (index + 1) % frames.length;
      var el = frames[index];
      el.style.zIndex = ++layer;
      el.style.transition = 'none';
      el.style.clipPath = 'inset(0 100% 0 0)';
      /* Force layout so the browser treats the clipped state as a
         starting point; without it both changes collapse into one
         and the view simply appears. */
      void el.offsetWidth;
      el.style.transition = 'clip-path ' + WIPE_MS + 'ms cubic-bezier(.6,.01,.2,1)';
      el.style.clipPath = 'inset(0 0 0 0)';
    }

    function stop() {
      if (startTimer) {
        clearTimeout(startTimer);
        startTimer = null;
      }
      if (stepTimer) {
        clearInterval(stepTimer);
        stepTimer = null;
      }
    }

    function start() {
      if (reduceMotion) return;
      stop();
      startTimer = setTimeout(function () {
        next();
        stepTimer = setInterval(next, STEP_MS);
      }, HOLD_MS);
    }

    reset();
    slide.addEventListener('mouseenter', start);
    slide.addEventListener('mouseleave', function () {
      stop();
      reset();
    });
    slide.addEventListener('focusin', start);
    slide.addEventListener('focusout', function () {
      stop();
      reset();
    });
  }

  function initClick(slide) {
    if (slide.dataset.stpClick) return;
    var link = slide.querySelector('a[href*="/products/"]');
    if (!link) return;
    slide.dataset.stpClick = '1';
    var url = link.getAttribute('href');

    slide.addEventListener('click', function (e) {
      /* Anything already interactive keeps its own behaviour: the
         title link, Quick View, a badge link. */
      if (e.target.closest('a, button')) return;
      /* Modified clicks behave as they would on a real link. */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      window.location.href = url;
    });
  }

  function boot() {
    var slides = document.querySelectorAll('.stp-reel__slide');
    [].forEach.call(slides, function (slide) {
      initFrames(slide);
      initClick(slide);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The recommendations arrive by AJAX and the reels are built from
     them afterwards, so anything set up at load misses them (§4.7).
     Both steps above are guarded by a dataset flag, so re-running is
     free. */
  var hosts = document.querySelectorAll(
    'product-recommendations, .related-products, .stp-reels'
  );
  [].forEach.call(hosts, function (host) {
    new MutationObserver(boot).observe(host, { childList: true, subtree: true });
  });
})();

/* ============================================================
   PHASE 29 — Home: "The Wall Label"
   Paired with sections/luxury-home.liquid and the Phase 29 CSS.

   Two behaviours:
     · the gallery label beside the column follows whichever
       photograph is crossing the middle of the screen
     · the frontispiece plate turns by clip-path wipe, the same
       sweep the catalogue cards and the reels use

   Everything is guarded by dataset flags and re-runs on the theme
   editor's section events, so a merchant editing the section in
   the customiser gets working behaviour without a reload.

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var WIPE_MS = 1100;
  var TURN_MS = 5400;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var timers = [];

  /* ---------- the label follows the wall ---------- */
  function bindWall(root) {
    var labels = [].slice.call(root.querySelectorAll('[data-stp-label]'));
    var figs = [].slice.call(root.querySelectorAll('[data-stp-fig]'));
    if (!labels.length || !figs.length) return;

    function show(i) {
      labels.forEach(function (el) {
        el.classList.toggle('is-on', el.dataset.stpLabel === String(i));
      });
    }
    show(0);

    /* A tall band across the middle of the viewport: whichever
       photograph is crossing it owns the label. Watching the middle
       rather than the top means the label changes when the piece is
       actually being looked at, not when it first appears. */
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) show(parseInt(e.target.dataset.stpFig, 10));
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );
    figs.forEach(function (f) { io.observe(f); });
  }

  /* ---------- the frontispiece turns ---------- */
  function bindFront(root) {
    var plate = root.querySelector('[data-stp-front]');
    if (!plate || plate.dataset.stpBound) return;

    var imgs = [].slice.call(plate.querySelectorAll('img'));
    if (imgs.length < 2) return;
    plate.dataset.stpBound = '1';

    var cap = plate.querySelector('[data-stp-front-cap]');
    var caps = [];
    var json = plate.querySelector('[data-stp-front-caps]');
    if (json) {
      try { caps = JSON.parse(json.textContent) || []; } catch (err) { caps = []; }
    }

    if (reduceMotion) return;

    var at = 0;
    timers.push(setInterval(function () {
      at = (at + 1) % imgs.length;
      var showing = at;
      var el = imgs[at];
      el.style.zIndex = 2;
      el.style.transition = 'none';
      el.style.clipPath = 'inset(0 0 0 100%)';
      /* Force layout so the browser treats the clipped state as a
         starting point; without it both changes collapse into one
         and the plate simply appears. */
      void el.offsetWidth;
      el.style.transition = 'clip-path ' + WIPE_MS + 'ms cubic-bezier(.6,.01,.2,1)';
      el.style.clipPath = 'inset(0 0 0 0)';
      if (cap && caps[at]) cap.textContent = caps[at];

      /* Once the sweep has finished the incoming photograph covers
         the frame completely, so everything behind it can be reset.
         Without this the layer number climbs for as long as the page
         is open. The guard covers a backgrounded tab, where timers
         are throttled and the next turn can start first. */
      setTimeout(function () {
        if (showing !== at) return;
        imgs.forEach(function (other, i) {
          if (i === at) return;
          other.style.transition = 'none';
          other.style.clipPath = 'inset(0 0 0 100%)';
          other.style.zIndex = 0;
        });
        el.style.zIndex = 1;
      }, WIPE_MS + 80);
    }, TURN_MS));
  }

  /* ---------- reveals ---------- */
  var reveal = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          reveal.unobserve(e.target);
        }
      });
    },
    { threshold: .1 }
  );

  function bindReveals(root) {
    root.querySelectorAll('.stp-home-rv').forEach(function (el) {
      if (el.dataset.stpRv) return;
      el.dataset.stpRv = '1';
      reveal.observe(el);
    });
  }

  function boot() {
    var homes = document.querySelectorAll('.stp-home');
    [].forEach.call(homes, function (root) {
      bindFront(root);
      bindReveals(root);
      if (!root.dataset.stpWall) {
        root.dataset.stpWall = '1';
        bindWall(root);
      }
    });
  }

  function reboot() {
    timers.forEach(clearInterval);
    timers = [];
    boot();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* The theme editor replaces the section's markup on every setting
     change, which drops the observers and the timers with it. */
  document.addEventListener('shopify:section:load', reboot);
  document.addEventListener('shopify:section:unload', function () {
    timers.forEach(clearInterval);
    timers = [];
  });
  document.addEventListener('shopify:block:select', reboot);
})();

/* ============================================================
   PHASE 33 — The cart, previewed on hover
   Paired with the Phase 33 CSS.

   The cart could only be reached by clicking through to /cart.
   Hovering the cart link now opens the same notification panel
   Dawn already shows after an add, filled with what is actually
   in the cart.

   Everything here is ADDITIVE. The link keeps its href, the click
   still goes to the cart, and Dawn's own add-to-cart path is not
   touched. If any part of this fails the hover simply does
   nothing — nothing on the path to checkout depends on it.

   Three things worth knowing about the implementation:

   · Hover only exists on a fine pointer. On a phone, hovering is
     the first half of a tap, so the panel would fly open on the
     way to the cart. Guarded by a media query.

   · The panel is filled from the Section Rendering API with the
     WHOLE cart-notification-product section, which loops over every
     line in the cart. Dawn's own renderContents() is not used here:
     it looks up a single line by key, because it exists to announce
     the one item just added. A preview should show everything.

   · Opening and closing are both delayed. Without the open delay
     the panel flashes at anyone whose pointer crosses the header;
     without the close delay it shuts while the pointer is still
     travelling down to it.

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var OPEN_DELAY = 160;
  var CLOSE_DELAY = 360;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  var openTimer = null;
  var closeTimer = null;
  var inFlight = false;
  var peeking = false;
  var originalHeading = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function notification() {
    return document.querySelector('cart-notification');
  }

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function panel() {
    return document.getElementById('cart-notification');
  }

  /* The section wraps its content in #shopify-section-<name> when it
     comes back from the Section Rendering API. Everything inside that
     wrapper is what belongs in the panel. */
  function innerOf(html, name) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.getElementById('shopify-section-' + name) || doc.body;
    return el ? el.innerHTML : null;
  }

  /* Deliberately NOT Dawn's renderContents(). That method looks up a
     single line by key — it exists to show the one item just added.
     cart-notification-product.liquid loops over the whole cart, so
     rendering the section entire shows everything in it, which is
     what a preview should be. Dawn's own add-to-cart path is
     untouched and still uses renderContents as before. */
  function hasLines(html) {
    return !!html && html.indexOf('cart-notification-product-') !== -1;
  }

  function fillAndOpen() {
    var host = notification();
    if (!host) return;
    if (inFlight) return;
    inFlight = true;

    fetch(
      root() +
        '?sections=cart-notification-product,cart-notification-button,cart-live-region-text'
    )
      .then(function (res) {
        if (!res.ok) throw new Error('sections unavailable');
        return res.json();
      })
      .then(function (sections) {
        var productHtml = sections['cart-notification-product'];
        /* No line ids means no items — an empty cart has nothing
           worth previewing, so the hover is simply ignored. */
        if (!hasLines(productHtml)) throw new Error('cart is empty');

        var productSlot = document.getElementById('cart-notification-product');
        var buttonSlot = document.getElementById('cart-notification-button');
        if (!productSlot) throw new Error('no slot to fill');

        productSlot.innerHTML = innerOf(productHtml, 'cart-notification-product');
        if (buttonSlot) {
          var buttonHtml = innerOf(sections['cart-notification-button'], 'cart-notification-button');
          if (buttonHtml) buttonSlot.innerHTML = buttonHtml;
        }

        markPeeking(true);
        if (typeof host.open === 'function') host.open();
      })
      .catch(function () {
        /* Fall back to whatever the panel already holds, but only if
           something was genuinely added earlier in this session —
           never open an empty shell. */
        var product = document.getElementById('cart-notification-product');
        if (product && product.innerHTML.trim() && typeof host.open === 'function') {
          markPeeking(true);
          host.open();
        }
      })
      .then(function () {
        inFlight = false;
      });
  }

  /* The panel's heading reads "Item added to your cart", which is
     untrue when it was opened by hovering. The original is kept and
     put back on close, so a real add still says the right thing. */
  function markPeeking(on) {
    var box = panel();
    if (!box) return;
    var heading = box.querySelector('.cart-notification__heading__text, .cart-notification__heading');
    peeking = on;

    if (on) {
      box.classList.add('stp-peek');
      if (heading) {
        if (originalHeading === null) originalHeading = heading.textContent;
        heading.textContent = 'In your cart';
      }
    } else {
      box.classList.remove('stp-peek');
      if (heading && originalHeading !== null) {
        heading.textContent = originalHeading;
        originalHeading = null;
      }
    }
  }

  function openSoon() {
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    openTimer = setTimeout(function () {
      var side = drawer();
      /* A cart drawer, where one is in use, is the better surface:
         it holds the whole cart rather than a single line. */
      if (side && typeof side.open === 'function') {
        side.open();
        return;
      }
      fillAndOpen();
    }, OPEN_DELAY);
  }

  function closeSoon() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      /* Only ever close what this script opened. A panel raised by a
         real add-to-cart is the shopper's to dismiss. */
      if (!peeking) return;
      var host = notification();
      if (host && typeof host.close === 'function') host.close();
      markPeeking(false);
    }, CLOSE_DELAY);
  }

  function bind() {
    /* Scoped to the header. The panel contains its own "View cart"
       link, and binding that as a trigger would make leaving it
       schedule a close while the pointer was still inside the
       panel — it would shut under the shopper's hand. */
    var triggers = document.querySelectorAll(
      '#cart-icon-bubble, .header__icon--cart, .header a[href$="/cart"], header a[href$="/cart"]'
    );
    [].forEach.call(triggers, function (el) {
      if (el.dataset.stpPeek) return;
      if (el.closest('cart-notification, cart-drawer, .cart-notification')) return;
      el.dataset.stpPeek = '1';
      el.addEventListener('mouseenter', openSoon);
      el.addEventListener('mouseleave', closeSoon);
      /* Clicking through should not leave a preview hanging open
         behind the cart page during the navigation. */
      el.addEventListener('click', function () {
        clearTimeout(openTimer);
      });
    });

    var box = panel();
    if (box && !box.dataset.stpPeek) {
      box.dataset.stpPeek = '1';
      box.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
      });
      box.addEventListener('mouseleave', closeSoon);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  /* The header re-renders on cart updates, which drops the listeners
     with it; the panel itself is only in the DOM once its section has
     loaded. Both are re-bound whenever the document changes.

     Coalesced to one call per frame: several other blocks on this
     site run their own observers, and an unthrottled bind would run
     once per mutation any of them caused. Only childList is watched,
     so the dataset flags bind() writes cannot re-trigger it. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      bind();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   PHASE 34 — The cart: "The Rail, full height"
   Paired with the Phase 34 CSS.

   Dawn's cart markup is left intact — every line update, the
   quantity inputs, the remove buttons and the checkout button are
   still Dawn's. This adds four things around them:

     · --stp-nav, the measured header height, so the page can be
       exactly one screen tall whatever logo is uploaded
     · the lead column at the head of the rail, holding the title
       and the "continue shopping" link that Dawn renders above
       the table
     · the reckoning's eyebrow, note, piece count and shipping row,
       which Dawn's footer has no place for
     · a wheel handler, because a page that scrolls sideways still
       meets a wheel that scrolls down

   Dawn re-renders the whole cart section over AJAX on every
   quantity change, which throws away anything added here. So each
   step is idempotent and re-runs from a MutationObserver.

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var WORDS = [
    'No pieces', 'One piece', 'Two pieces', 'Three pieces', 'Four pieces',
    'Five pieces', 'Six pieces', 'Seven pieces', 'Eight pieces'
  ];

  function onCart() {
    return (
      document.querySelector('#main-cart-items, .cart-items') !== null &&
      location.pathname.indexOf('/cart') !== -1
    );
  }

  /* The CSS is scoped to main[data-template='cart']; guarantee it
     rather than trusting theme.liquid to still be writing it. */
  function stamp() {
    var main = document.querySelector('main');
    if (main && !main.getAttribute('data-template')) {
      main.setAttribute('data-template', 'cart');
    }
  }

  /* The header's height depends on the merchant's logo, so it is
     measured rather than assumed. */
  function measureNav() {
    var header =
      document.querySelector('.header-wrapper') || document.querySelector('.header');
    if (!header) return;
    var h = Math.round(header.getBoundingClientRect().height);
    if (h > 0) document.documentElement.style.setProperty('--stp-nav', h + 'px');
  }

  function pieceCount() {
    var inputs = document.querySelectorAll('.cart-item .quantity__input');
    var n = 0;
    [].forEach.call(inputs, function (input) {
      var v = parseInt(input.value, 10);
      if (!isNaN(v)) n += v;
    });
    return n;
  }

  /* ---------- 1. The lead column ----------
     Dawn renders the cart title and the continue-shopping link above
     the table. They are MOVED into the rail as its first column, so
     the photographs keep the whole height of the screen instead of
     surrendering a band of it to a heading.

     Built as a real <tr>/<td>: injecting a bare <div> into a <tbody>
     is invalid, and browsers move it out of the table when they
     parse it. */
  function buildLead() {
    /* The table is only rendered when the cart has something in it,
       so an empty cart simply has no rail to lead. */
    var body = document.querySelector('table.cart-items > tbody');
    if (!body || body.querySelector('.stp-lead')) return;

    var row = document.createElement('tr');
    row.className = 'stp-lead';
    var cell = document.createElement('td');
    row.appendChild(cell);

    var top = document.createElement('div');
    var eyebrow = document.createElement('span');
    eyebrow.className = 'stp-lead__eyebrow';
    eyebrow.textContent = 'The Order';
    top.appendChild(eyebrow);

    var title = document.querySelector('.title-wrapper-with-link .title--primary');
    if (title) {
      top.appendChild(title);
    } else {
      var h = document.createElement('h1');
      h.className = 'cart__title';
      h.textContent = 'Your cart';
      top.appendChild(h);
    }

    var count = document.createElement('p');
    count.className = 'stp-lead__count';
    count.setAttribute('data-stp-count', '');
    top.appendChild(count);
    cell.appendChild(top);

    var bottom = document.createElement('div');
    var back = document.querySelector('.title-wrapper-with-link .underlined-link');
    if (back) {
      bottom.appendChild(back);
    } else {
      var a = document.createElement('a');
      a.href = '/collections/all';
      a.textContent = 'Continue shopping \u2192';
      bottom.appendChild(a);
    }
    var cue = document.createElement('div');
    cue.className = 'stp-lead__cue';
    cue.textContent = 'Scroll across \u2192';
    bottom.appendChild(cue);
    cell.appendChild(bottom);

    body.insertBefore(row, body.firstChild);

    /* The emptied wrapper would otherwise sit above the rail carrying
       its own margin — the band under the header. It is NOT inside
       #main-cart-items, which is where this used to look for it: it
       is a sibling of the form, one level up in .page-width. The CSS
       hides it too, so this is belt and braces rather than the only
       thing holding the layout up. */
    var wrapper = document.querySelector('cart-items .title-wrapper-with-link');
    if (wrapper && !wrapper.querySelector('h1, a')) wrapper.remove();
  }

  /* ---------- 2. The reckoning's own lines ---------- */
  function buildReckon() {
    var footer = document.querySelector('.cart__footer');
    if (!footer || footer.querySelector('.stp-reckon__head')) return;

    var head = document.createElement('div');
    head.className = 'stp-reckon__head';
    head.innerHTML =
      '<span class="stp-reckon__eyebrow">The Parcel</span>' +
      '<h2 class="stp-reckon__title">Wrapped and sent from the workshop.</h2>' +
      '<p class="stp-reckon__note">Each piece is cut in small number and packed by ' +
      'hand in Shunde.</p>';
    footer.insertBefore(head, footer.firstChild);

    /* The piece and shipping rows sit immediately above Dawn's own
       subtotal, so the three read as one column of figures. */
    var totals = footer.querySelector('.totals');
    if (totals && totals.parentNode) {
      var rows = document.createElement('div');
      rows.className = 'stp-rows';
      rows.innerHTML =
        '<div class="stp-row"><span>Pieces</span><span data-stp-pieces>0</span></div>' +
        '<div class="stp-row"><span>Shipping</span><span>At checkout</span></div>';
      totals.parentNode.insertBefore(rows, totals);
    }

    var seal = document.createElement('div');
    seal.className = 'stp-reckon__seal';
    seal.setAttribute('aria-hidden', 'true');
    seal.textContent = '\u76db\u5510\u7261\u4e39';
    footer.appendChild(seal);
  }

  function syncCounts() {
    var n = pieceCount();
    var line = document.querySelector('[data-stp-count]');
    if (line) line.textContent = (WORDS[n] || n + ' pieces') + ', held for you.';
    var cell = document.querySelector('[data-stp-pieces]');
    if (cell) cell.textContent = n;
  }

  /* ---------- 3. The wheel, turned sideways ----------
     Horizontal input is left alone: trackpads and tilt wheels
     already do the right thing, and hijacking them fights the user. */
  function bindWheel() {
    var body = document.querySelector('table.cart-items > tbody');
    if (!body || body.dataset.stpWheel) return;
    body.dataset.stpWheel = '1';

    body.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (body.scrollWidth <= body.clientWidth) return;
        body.scrollLeft += e.deltaY;
        e.preventDefault();
      },
      { passive: false }
    );

    body.addEventListener('scroll', function () {
      if (body.scrollLeft > 40) body.classList.add('is-moved');
    });
  }

  function build() {
    if (!onCart()) return;
    stamp();
    measureNav();
    buildLead();
    buildReckon();
    syncCounts();
    bindWheel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  window.addEventListener('resize', measureNav);

  /* Dawn replaces the cart sections wholesale after every line
     change, taking the lead column and the reckoning's lines with
     them. Coalesced to one rebuild per frame, and every step above
     returns early when its work is already done, so re-running is
     free. */
  if (onCart()) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        build();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
/* ============================================================
   PHASE 50 — Quick View: swipe between views on touch

   The modal already has prev/next controls, wrapping at both
   ends, dots that follow the position, and an auto-advance timer
   that restarts on interaction — all of it inside the Phase 11
   IIFE with no way in from outside. So rather than reach for
   those internals or duplicate them, a swipe simply presses the
   arrow the shopper would have pressed. Everything downstream
   stays in one place, and this block cannot fall out of step with
   it.

   Delegated from document, because the modal is built on first
   open and its contents are replaced for every product.

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var SWIPE_MIN = 40; /* px of travel before a drag counts as a swipe */
  var SLOPE = 1.4; /* how much more horizontal than vertical it must be */

  /* "Mobile" here means a device that can actually swipe. A width
     query would leave a tablet without the gesture and hand a
     narrow desktop window one that no mouse can perform. */
  if (!window.matchMedia('(pointer: coarse)').matches) return;

  var x0 = null;
  var y0 = null;

  function inMedia(t) {
    return !!(t && t.closest && t.closest('.stp-quickview__media'));
  }

  /* The price, size select and Add to Cart sit inside the media
     box as overlays. A drag that starts on one of those is someone
     using the control, not turning the piece. */
  function onControls(t) {
    return !!(t && t.closest && t.closest('.stp-quickview__controls, .stp-quickview__nav'));
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      x0 = null;
      if (e.touches.length !== 1) return;
      var t = e.target;
      if (!inMedia(t) || onControls(t)) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      x0 = null;
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      x0 = null;

      if (Math.abs(dx) < SWIPE_MIN) return;
      /* Mostly vertical means the finger was scrolling, not
         swiping — leave it alone. */
      if (Math.abs(dx) < Math.abs(dy) * SLOPE) return;

      var root = document.querySelector('.stp-quickview.is-open');
      if (!root) return;
      /* The arrows only exist when the piece has more than one
         view, so a single-image product simply ignores the swipe. */
      var btn = root.querySelector(dx < 0 ? '[data-stp-next]' : '[data-stp-prev]');
      if (btn) btn.click();
    },
    { passive: true }
  );
})();

/* ============================================================
   PHASE 51 — The mobile filter panel, flattened (JS half)
   Paired with the Phase 51 CSS.

   The CSS dissolves each filter's drill-down submenu back into
   the panel, but a <details> whose contents are hidden because it
   is CLOSED cannot be opened by styling — that is the element's
   own behaviour. So the disclosures are opened here and held open,
   and the whole panel reads as one list.

   Held open rather than left as accordions because there are two
   filters: an accordion would put a tap between the shopper and
   every option for no gain. If the store ever grows a long list of
   filters, dropping the `toggle` guard below turns them back into
   accordions in place, which is still not a drill-down.

   Idempotent and re-run from an observer, because Dawn replaces
   the whole facets block over AJAX on every filter change.

   PASTE THIS AT THE END of custom.js.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE = '(max-width: 989px)';

  function flatten() {
    var rail = document.getElementById('main-collection-filters');
    if (!rail) return;
    if (!window.matchMedia(MOBILE).matches) return;

    var groups = rail.querySelectorAll('details.mobile-facets__details');
    [].forEach.call(groups, function (d) {
      if (!d.open) d.open = true;
      if (d.dataset.stpFlat) return;
      d.dataset.stpFlat = '1';

      /* Dawn's menu-drawer still listens on the summary and will
         close the group. Re-opening on `toggle` keeps the options
         on screen without fighting its handler for the event —
         setting `open` fires `toggle` once more, which then sees
         it already open and stops. */
      d.addEventListener('toggle', function () {
        if (!d.open) d.open = true;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flatten);
  } else {
    flatten();
  }

  window.addEventListener('resize', function () {
    clearTimeout(flatten._t);
    flatten._t = setTimeout(flatten, 200);
  });

  var host = document.getElementById('main-collection-filters');
  if (host) {
    new MutationObserver(flatten).observe(host, { childList: true, subtree: true });
  }
})();